import React from "react";
import "./About.css";

const About = () => {
  return (
    <div
      className="modal fade"
      tabIndex="-1"
      id="about"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content w-100">
          <div className="modal-header">
            <h5 className="modal-title">About Me</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <p className="text">
            Hi! 👋 My name is Adrian Martinez, a Full Stack Developer with
            experience in React, Node, Vue and CSS who wants to face new
            challenges in order to improve and learn.
          </p>
          <p className="text">
            If you want to work with me or your enterprise is interested in my
            profile, I encourage you to send a email to
            adrian.mart41197@gmail.com or visit my{" "}
            <a href="www.linkedin.com/in/adrian-martinez1997">
              LinkedIn Profile
            </a>{" "}
            if you want know more about me
          </p>
          <p className="text">I'm waiting for your message! Have a nice day.</p>
        </div>
      </div>
    </div>
  );
};

export default About;
